import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AppService } from 'src/@core/services/app.service';
import { fadeInUp400ms } from 'src/@core/animations/fade-in-up.animation';
import { stagger40ms } from 'src/@core/animations/stagger.animation';
import { fadeInRight400ms } from 'src/@core/animations/fade-in-right.animation';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatDialog, MatFormFieldDefaultOptions } from '@angular/material';
import { roles } from 'src/app/shared/helpers/roles-permissions';

@Component({
  selector: 'hour4u-admin-bookings',
  templateUrl: './bookings.component.html',
  styleUrls: ['./bookings.component.scss'],
  animations: [
    fadeInUp400ms,
    stagger40ms,
    fadeInRight400ms
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'standard'
      } as MatFormFieldDefaultOptions
    }
  ]
})
export class BookingsComponent implements OnInit {
  roles = roles;
  profile = this.appService.getCurrentAccount();
  currentUserRole: any = null;
  loginUserDetails: any = null;
  isLoading: boolean = false;
  bookingStatus: string = "";

  constructor(
    private appService: AppService,
    public dialog: MatDialog,
    public cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.getCurrentRole();
  }

  getCurrentRole() {
    this.appService.currentUser.subscribe(currentUser => {
      this.loginUserDetails = currentUser;
      if (currentUser && currentUser.roles && currentUser.roles.length) {
        currentUser.roles.forEach(ele => {
          this.currentUserRole = ele;
        })
      }
    })
  }

  // tab change
  onTabChanged(event) {
    console.log(event)
    if (event.index == 0) {
      this.bookingStatus = ""
    }
    if (event.index == 1) {
      this.bookingStatus = "ENQUIRY_POSTED"
    }
    if (event.index == 2) {
      this.bookingStatus = "QUOTATION_SENT"
    }
    if (event.index == 3) {
      this.bookingStatus = "APPROVED"
    }
    if (event.index == 4) {
      this.bookingStatus = "REJECTED"
    }
    this.cdr.detectChanges();
  }
}
